import React, { useEffect, useState } from 'react';
import { Paper, Typography, List, ListItem, ListItemAvatar, Avatar, ListItemText, Chip, Skeleton, Box } from '@mui/material';
import { People } from '@mui/icons-material';
import { dashboardAPI } from '../services/api';
import { useNavigate } from 'react-router-dom';

import { BRAND, BLUE_GRADIENT } from '../theme/fitisticTokens';

export default function TopActiveUsersWidget({ days = 30, limit = 8 }) {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { load(); }, [days]); // eslint-disable-line react-hooks/exhaustive-deps

  const load = async () => {
    try {
      const res = await dashboardAPI.getTopActiveUsers({ days, limit });
      setData(res.data.data || []);
    } catch (err) {
      console.error('TopActiveUsers load error', err);
      setData([]);
    }
  };

  return (
    <Paper elevation={0} sx={{ p: 2.25, border: 1, borderColor: 'divider', borderRadius: 1.5, height: '100%' }}>
      <Typography sx={{ fontSize: 15, fontWeight: 800, color: 'text.primary', mb: 0.25 }}>Top Active Users</Typography>
      <Typography sx={{ fontSize: 12, color: 'text.secondary', mb: 2 }}>Most workout sessions in the last {days} days</Typography>
      {!data ? (
        <Box>
          {[...Array(5)].map((_, i) => (
            <Skeleton key={i} height={42} sx={{ mb: 1, borderRadius: 1 }} />
          ))}
        </Box>
      ) : data.length === 0 ? (
        <Typography variant="body2" color="text.secondary">No activity yet</Typography>
      ) : (
        <List disablePadding>
          {data.map((u) => (
            <ListItem
              key={u.userId}
              button
              onClick={() => navigate(`/dashboard/users/${u.userId}/analytics`)}
              sx={{
                borderRadius: 1,
                mb: 0.5,
                transition: 'background-color 0.15s ease',
                '&:hover': { bgcolor: 'action.hover' },
              }}
            >
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: BRAND.primary, color: '#FFFFFF', fontWeight: 700, fontSize: 13, width: 34, height: 34 }}>
                  {u.name?.[0]?.toUpperCase() || '?'}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={<Typography sx={{ fontSize: 13, fontWeight: 700 }} noWrap>{u.name || u.email || 'Unknown'}</Typography>}
                secondary={<Typography sx={{ fontSize: 12, color: 'text.secondary' }} noWrap>{u.email}</Typography>}
              />
              <Chip
                label={`${u.sessions} sessions`}
                size="small"
                sx={{
                  fontWeight: 700,
                  fontSize: 11,
                  bgcolor: BRAND.primarySoft,
                  color: BRAND.primaryDark,
                  border: `1px solid ${BRAND.primarySoftBorder}`,
                }}
              />
            </ListItem>
          ))}
        </List>
      )}
    </Paper>
  );
}
